var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputInteger",staticClass:"input",class:_vm.inputClasses,style:({ 'font-family': _vm.fontFamily }),attrs:{"readonly":_vm.readonly,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"type":"text","onClick":"this.select();"},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"keypress":_vm.onKeyPress,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }